angular.module('admin.directives')

  .directive('stat', ['Dictionary', 'HelperService', 'HomeService', 'AgentService', 'UserService', 'LoanService', 'HomeActivity', function(Dictionary, Helpers, HomeService, AgentService, UserService, LoanService, HomeActivity){
    return {
      restrict: 'EA',
      controllerAs: 'statCtrl',
      bindToController: {
        startDate: '=',
        agentId: '@',
        stat: '@',
      },
      scope: {},
      template: '{{statCtrl.statVal | number}}',

      controller: function(){
        var dataCall;
        var ctrl = this;
        var where = {};

        function success(statVal){
          ctrl.statVal = statVal.count;
        }

        function error(err){
          ctrl.error = err;
        }

        if(ctrl.agentId)
          where.agentId = ctrl.agentId;

        if(ctrl.startDate)
          where.created = { gte: moment(ctrl.startDate).toDate() };

        if(ctrl.stat === 'agents')
          dataCall = AgentService.count;

        else if(ctrl.stat === 'homes')
          dataCall = HomeService.count;

        else if(ctrl.stat === 'users')
          dataCall = UserService.count;

        else if(ctrl.stat === 'loans')
          dataCall = LoanService.count;

        else if(ctrl.stat === 'digests-texted'){
          dataCall = HomeActivity.count;
          where.source = "twilio";
          where.event = "sent";
        }else if(ctrl.stat === 'text-clicks'){
          dataCall = HomeActivity.count;
          where.source = "twilio";
          where.event = "view";
        }else if(ctrl.stat === 'digests-emailed'){
          dataCall = HomeActivity.count;
          where.source = "mandrill";
          where.event = "sent";
        }else if(ctrl.stat === 'email-opens'){
          dataCall = HomeActivity.count;
          where.source = "mandrill";
          where.event = "open";
        }else if(ctrl.stat === 'email-clicks'){
          dataCall = HomeActivity.count;
          where.source = "mandrill";
          where.event = "click";
        }else if(ctrl.stat === 'web-views'){
          dataCall = HomeActivity.count;
          where.event = "view";
        }else if(ctrl.stat === 'cma-request'){
          dataCall = HomeActivity.count;
          where.source = "user";
          where.event = "cma-request";
        }else if(ctrl.stat === 'unsent-users'){
          dataCall = UserService.count;
          where.digestHasBeenSent = false;
        }else if(ctrl.stat === 'invalid-users'){
          dataCall = UserService.count;
          where.emailValid = false;
        }
        // else if(ctrl.stat === 'unsubscribed-users'){
        //   dataCall = UserService.count;
        //   where.digestEmailUnsubscribed = {neq: true};
        // }

        ctrl.refreshData = function(){
          dataCall({where:where})
            .then(success)
            .catch(error);
        };

        ctrl.refreshData();
      }
    }

  }]);
